import { UIHeading4 } from '@cian/ui-kit';

export const getUTP = (onModalClick: () => void, onLinkClick: () => void) => {
  return [
    {
      title: 'Надёжный агент для решения любых задач',
      imageClass: 'shield',
      toolTipText: 'Подключаем к программе только проверенных партнёров и контролируем качество их работы',
      button: (
        <div onClick={onModalClick}>
          <UIHeading4 color="text-main-default">Правила работы риелторов</UIHeading4>
        </div>
      ),
    },
    {
      title: `Покупка пройдет безопасно`,
      imageClass: 'docs',
      toolTipText:
        'Специалист проведёт юридическую проверку объекта перед покупкой и вы получите гарантию от потери права собственности',
      button: (
        <a
          href="https://static.cdn-cian.ru/frontend/collections-assets/cpd/landing/sert.pdf"
          target="_blank"
          rel="noreferrer"
          onClick={onLinkClick}
        >
          <UIHeading4 color="text-main-default">Пример сертификата</UIHeading4>
        </a>
      ),
    },
    {
      title: 'Хотите сначала продать своё жильё? Поможем и с этим!',
      imageClass: 'homes',
      toolTipText:
        'Агент поможет найти покупателя и продавца, проведёт все переговоры, подберёт удобные даты и поможет с оформлением.',
    },
  ];
};
